import { loadScriptInHead } from '../../utils/dom';

export const COMSCORE_CLIENT_ID = '7395029';

/**
 * Implementation spec:
 * https://direct.comscore.com/clients/docs/comScoreImplementationSpecs-Publishers.pdf
 */
export default function Comscore() {
    window._comscore = window._comscore || [];
    window._comscore.push({
      c1: 2,
      c2: COMSCORE_CLIENT_ID,
      c3: window.location.hostname,
      c4: window.location.href,
      c5: '',
      c6: '',
      c15: ''
    });

    const protocol = document.location.protocol === "https:" ? "https://sb" : "http://b";
    loadScriptInHead('statistics', `${protocol}.scorecardresearch.com/cs/${COMSCORE_CLIENT_ID}/beacon.js`);
}
